import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TranslateService {
  data: any = {};

  constructor(private http: HttpClient) {
  }

  public async loadTranslation(lang: string): Promise<any> {
    const langPath = `assets/i18n/${lang || 'de'}.json`;

    try {
      const translation = await firstValueFrom(this.http.get<{}>(langPath));
      this.data = Object.assign({}, translation || {});
      return this.data;
    } catch (error) {
      this.data = {};
      return this.data;
    }
  }

  get(key?: string): any {
    if (!key) {
      return this.data;
    }

    const keys = key.split('.');
    let result = this.data;

    for (const k of keys) {
      if (result && typeof result === 'object' && k in result) {
        result = result[k];
      } else {
        return undefined;
      }
    }
    return result;
  }
}
